import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ServiceAreas = () => {
  useEffect(() => {
    // Set page title
    document.title = "Service Areas - Industrial Equipment Buyers Texas Oklahoma Louisiana | 9 States Coverage";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'ValveSalesSupply serves 9 states: Texas, Oklahoma, Louisiana, New Mexico, Kansas, North Dakota, South Dakota, Wyoming, Utah. Professional industrial equipment buyers with fast response times, local expertise, and competitive pricing for refineries and petrochemical plants.');
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'industrial equipment buyers service areas, valve buyers Texas Oklahoma Louisiana, multi-state equipment buyers, refinery equipment buyers coverage, industrial equipment purchasing regions');
    }

    // Add canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/service-areas');

    // Add Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Service Areas - Industrial Equipment Buyers Across 9 States | ValveSalesSupply' },
      { property: 'og:description', content: 'Serving Texas, Oklahoma, Louisiana, New Mexico, Kansas, North Dakota, South Dakota, Wyoming, and Utah with professional industrial equipment purchasing services.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/service-areas' },
      { property: 'og:type', content: 'website' }
    ];

    ogTags.forEach(tag => {
      let meta = document.querySelector(`meta[property="${tag.property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', tag.property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/service-areas/#webpage",
          "url": "https://valvesalessupply.com/service-areas",
          "name": "Service Areas - Industrial Equipment Buyers Across 9 States",
          "description": "ValveSalesSupply serves Texas, Oklahoma, Louisiana, New Mexico, Kansas, North Dakota, South Dakota, Wyoming, and Utah with professional industrial equipment purchasing services.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Service Areas",
                "item": "https://valvesalessupply.com/service-areas"
              }
            ]
          }
        },
        {
          "@type": "Service",
          "name": "Multi-State Industrial Equipment Purchasing",
          "description": "Professional industrial equipment purchasing services across 9 states in the central United States",
          "provider": {
            "@id": "https://valvesalessupply.com/#organization"
          },
          "serviceArea": [
            {
              "@type": "State",
              "name": "Texas",
              "addressRegion": "TX",
              "addressCountry": "US"
            },
            {
              "@type": "State", 
              "name": "Oklahoma",
              "addressRegion": "OK",
              "addressCountry": "US"
            },
            {
              "@type": "State",
              "name": "Louisiana", 
              "addressRegion": "LA",
              "addressCountry": "US"
            },
            {
              "@type": "State",
              "name": "New Mexico",
              "addressRegion": "NM", 
              "addressCountry": "US"
            },
            {
              "@type": "State",
              "name": "Kansas",
              "addressRegion": "KS",
              "addressCountry": "US"
            },
            {
              "@type": "State",
              "name": "North Dakota",
              "addressRegion": "ND",
              "addressCountry": "US"
            },
            {
              "@type": "State",
              "name": "South Dakota",
              "addressRegion": "SD",
              "addressCountry": "US"
            },
            {
              "@type": "State",
              "name": "Wyoming",
              "addressRegion": "WY",
              "addressCountry": "US"
            },
            {
              "@type": "State",
              "name": "Utah",
              "addressRegion": "UT",
              "addressCountry": "US"
            }
          ]
        },
        {
          "@type": "ItemList",
          "name": "Major Cities We Serve",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Place",
                "name": "Houston, Texas",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Houston",
                  "addressRegion": "TX",
                  "addressCountry": "US"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Place",
                "name": "Dallas, Texas",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Dallas", 
                  "addressRegion": "TX",
                  "addressCountry": "US"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "Place",
                "name": "Oklahoma City, Oklahoma",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Oklahoma City",
                  "addressRegion": "OK",
                  "addressCountry": "US"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 4,
              "item": {
                "@type": "Place",
                "name": "Baton Rouge, Louisiana",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Baton Rouge",
                  "addressRegion": "LA", 
                  "addressCountry": "US"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 5,
              "item": {
                "@type": "Place",
                "name": "Albuquerque, New Mexico",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Albuquerque",
                  "addressRegion": "NM",
                  "addressCountry": "US"
                }
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const serviceStates = [
    {
      name: 'Texas',
      abbreviation: 'TX',
      slug: 'texas',
      description: 'Houston, Dallas, Austin, San Antonio, Beaumont, Corpus Christi, Midland',
      facilities: '300+ Facilities',
      responseTime: '4-8 Hours',
      specialties: ['Refining', 'Petrochemicals', 'Gas Processing']
    },
    {
      name: 'Oklahoma',
      abbreviation: 'OK',
      slug: 'oklahoma',
      description: 'Oklahoma City, Tulsa, Lawton, Ponca City, Ardmore',
      facilities: '150+ Facilities',
      responseTime: '4-8 Hours',
      specialties: ['Oil & Gas', 'Refining', 'Power Generation']
    },
    {
      name: 'Louisiana',
      abbreviation: 'LA',
      slug: 'louisiana',
      description: 'Baton Rouge, Lake Charles, New Orleans, Lafayette, Shreveport',
      facilities: '200+ Facilities',
      responseTime: '4-8 Hours',
      specialties: ['Petrochemicals', 'Refining', 'LNG']
    },
    {
      name: 'New Mexico',
      abbreviation: 'NM',
      slug: 'new-mexico',
      description: 'Albuquerque, Roswell, Hobbs, Artesia, Carlsbad',
      facilities: '75+ Facilities',
      responseTime: '8-12 Hours',
      specialties: ['Oil & Gas', 'Mining', 'Power Generation']
    },
    {
      name: 'Kansas',
      abbreviation: 'KS',
      slug: 'kansas',
      description: 'Wichita, Kansas City, Topeka, Coffeyville, El Dorado',
      facilities: '100+ Facilities',
      responseTime: '8-12 Hours',
      specialties: ['Refining', 'Agriculture', 'Manufacturing']
    },
    {
      name: 'North Dakota',
      abbreviation: 'ND',
      slug: 'north-dakota',
      description: 'Bismarck, Fargo, Williston, Minot, Dickinson',
      facilities: '50+ Facilities',
      responseTime: '12-24 Hours',
      specialties: ['Oil & Gas', 'Power Generation', 'Agriculture']
    },
    {
      name: 'South Dakota',
      abbreviation: 'SD',
      slug: 'south-dakota',
      description: 'Sioux Falls, Rapid City, Aberdeen, Pierre, Watertown',
      facilities: '40+ Facilities',
      responseTime: '12-24 Hours',
      specialties: ['Power Generation', 'Agriculture', 'Mining']
    },
    {
      name: 'Wyoming',
      abbreviation: 'WY',
      slug: 'wyoming',
      description: 'Cheyenne, Casper, Laramie, Gillette, Rock Springs',
      facilities: '60+ Facilities',
      responseTime: '12-24 Hours',
      specialties: ['Oil & Gas', 'Mining', 'Power Generation']
    },
    {
      name: 'Utah',
      abbreviation: 'UT',
      slug: 'utah',
      description: 'Salt Lake City, Provo, Ogden, West Valley, Orem',
      facilities: '45+ Facilities',
      responseTime: '12-24 Hours',
      specialties: ['Mining', 'Manufacturing', 'Power Generation']
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 sm:pt-24 pb-12 sm:pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/e1bf9b87e7526f7e397bdcc61b165e90.jpg')`
          }}
          role="img"
          aria-label="Map of central United States showing ValveSalesSupply service coverage across 9 states with major industrial facilities and refineries"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/80 to-[#1B3A5F]/60"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center text-white">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">OUR SERVICE AREAS</h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-200 max-w-3xl mx-auto">
            Serving 9 major industrial states across the central United States with fast response times 
            and local expertise in industrial equipment purchasing.
          </p>

          {/* External Links for Major Industrial Cities */}
          <div className="mt-8 sm:mt-12 text-gray-200 text-sm">
            <p className="mb-4">Major industrial hubs in our service area:</p>
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
              <a 
                href="https://www.greaterhouston.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-200 hover:text-white underline"
              >
                Greater Houston Partnership
              </a>
              <a 
                href="https://www.dallasecodev.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-200 hover:text-white underline"
              >
                Dallas Economic Development
              </a>
              <a 
                href="https://www.okc.gov/departments/economic-development" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-200 hover:text-white underline"
              >
                Oklahoma City Economic Development
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Service Coverage Map */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
            {/* Map Visual */}
            <div className="order-2 lg:order-1">
              <div className="bg-[#F5F7FA] rounded-xl sm:rounded-2xl lg:rounded-3xl p-4 sm:p-6 lg:p-8 text-center relative overflow-hidden">
                <div className="relative z-10">
                  <h3 className="text-[#6B7280] uppercase text-xs sm:text-sm font-semibold mb-3 sm:mb-4 tracking-wider">SERVICE COVERAGE</h3>
                  <div className="grid grid-cols-3 gap-2 sm:gap-3 lg:gap-4 text-center">
                    {serviceStates.map((state) => (
                      <Link
                        key={state.abbreviation}
                        to={`/${state.slug}`}
                        className="bg-[#1B3A5F] text-white p-2 sm:p-3 rounded-lg font-bold text-sm sm:text-base lg:text-lg hover:bg-[#2B4A6F] transition-all duration-300 cursor-pointer"
                      >
                        {state.abbreviation}
                      </Link>
                    ))}
                  </div>
                  <div className="mt-4 sm:mt-6 lg:mt-8 text-center">
                    <div className="text-[#1B3A5F] text-2xl sm:text-3xl lg:text-4xl font-bold">1,000+</div>
                    <div className="text-gray-600 text-xs sm:text-sm lg:text-base">Industrial Facilities Served</div>
                  </div>
                </div>
                <div className="absolute inset-0 opacity-10">
                  <i className="ri-map-2-line text-[150px] sm:text-[200px] lg:text-[300px] text-[#1B3A5F]"></i>
                </div>
              </div>
            </div>
            
            {/* Content */}
            <div className="order-1 lg:order-2">
              <h2 className="text-[#1B3A5F] text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4 lg:mb-6">COMPREHENSIVE REGIONAL COVERAGE</h2>
              <p className="text-gray-600 text-sm sm:text-base lg:text-lg mb-4 sm:mb-6 lg:mb-8 leading-relaxed">
                Our strategic location in the heart of America's industrial corridor allows us to provide 
                rapid response times and local expertise across 9 major industrial states. We understand 
                the unique needs of each region and maintain strong relationships with facilities throughout our service area.
              </p>
              
              <div className="space-y-3 sm:space-y-4 lg:space-y-6">
                <div className="flex items-start">
                  <div className="w-8 sm:w-10 lg:w-12 h-8 sm:h-10 lg:h-12 bg-[#1B3A5F] rounded-full flex items-center justify-center mr-3 sm:mr-4 mt-1">
                    <i className="ri-time-line text-white text-sm sm:text-lg lg:text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-[#1B3A5F] font-bold text-sm sm:text-base lg:text-lg mb-1 sm:mb-2">Fast Response Times</h4>
                    <p className="text-gray-600 text-xs sm:text-sm lg:text-base">4-24 hour response depending on location, with priority given to turnaround schedules.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 sm:w-10 lg:w-12 h-8 sm:h-10 lg:h-12 bg-[#1B3A5F] rounded-full flex items-center justify-center mr-3 sm:mr-4 mt-1">
                    <i className="ri-team-line text-white text-sm sm:text-lg lg:text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-[#1B3A5F] font-bold text-sm sm:text-base lg:text-lg mb-1 sm:mb-2">Local Expertise</h4>
                    <p className="text-gray-600 text-xs sm:text-sm lg:text-base">Regional teams with deep knowledge of local industrial operations and regulations.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 sm:w-10 lg:w-12 h-8 sm:h-10 lg:h-12 bg-[#1B3A5F] rounded-full flex items-center justify-center mr-3 sm:mr-4 mt-1">
                    <i className="ri-truck-line text-white text-sm sm:text-lg lg:text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-[#1B3A5F] font-bold text-sm sm:text-base lg:text-lg mb-1 sm:mb-2">Complete Logistics</h4>
                    <p className="text-gray-600 text-xs sm:text-sm lg:text-base">Full-service pickup and transportation with all necessary permits and documentation.</p>
                  </div>
                </div>
              </div>
              
              <Link
                to="/contact"
                className="bg-[#1B3A5F] text-white px-4 sm:px-6 lg:px-8 py-3 sm:py-4 rounded-full font-semibold text-sm sm:text-base lg:text-lg hover:bg-[#2B4A6F] transition-all duration-300 inline-flex items-center mt-4 sm:mt-6 lg:mt-8 whitespace-nowrap"
              >
                CONTACT YOUR REGIONAL TEAM
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* State by State Coverage */}
      <section className="py-12 sm:py-16 lg:py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-[#1B3A5F] text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4">STATE-BY-STATE COVERAGE</h2>
            <p className="text-gray-600 text-base sm:text-lg lg:text-xl">Detailed service information for each state in our coverage area</p>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {serviceStates.map((state, index) => (
              <Link 
                key={index} 
                to={`/${state.slug}`}
                className="bg-white rounded-xl sm:rounded-2xl lg:rounded-3xl p-4 sm:p-6 lg:p-8 hover:shadow-lg transition-all duration-300 cursor-pointer block"
              >
                <div className="flex items-center mb-3 sm:mb-4 lg:mb-6">
                  <div className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 bg-[#1B3A5F] rounded-xl sm:rounded-2xl flex items-center justify-center mr-2 sm:mr-3 lg:mr-4">
                    <span className="text-white text-sm sm:text-lg lg:text-xl font-bold">{state.abbreviation}</span>
                  </div>
                  <h3 className="text-[#1B3A5F] text-lg sm:text-xl lg:text-2xl font-bold">{state.name}</h3>
                </div>
                
                <div className="space-y-2 sm:space-y-3 lg:space-y-4">
                  <div>
                    <h4 className="text-gray-800 font-semibold mb-1 sm:mb-2 text-xs sm:text-sm lg:text-base">Major Cities:</h4>
                    <p className="text-gray-600 text-xs sm:text-sm">{state.description}</p>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-2 sm:gap-3 lg:gap-4">
                    <div>
                      <h5 className="text-[#1B3A5F] font-semibold text-xs sm:text-sm">Facilities</h5>
                      <p className="text-gray-600 text-xs sm:text-sm">{state.facilities}</p>
                    </div>
                    <div>
                      <h5 className="text-[#1B3A5F] font-semibold text-xs sm:text-sm">Response</h5>
                      <p className="text-gray-600 text-xs sm:text-sm">{state.responseTime}</p>
                    </div>
                  </div>
                  
                  <div>
                    <h4 className="text-gray-800 font-semibold mb-2 text-xs sm:text-sm lg:text-base">Specialties:</h4>
                    <div className="flex flex-wrap gap-1 sm:gap-2">
                      {state.specialties.map((specialty, specIndex) => (
                        <span key={specIndex} className="bg-[#1B3A5F]/10 text-[#1B3A5F] px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                
                <div className="mt-3 sm:mt-4 lg:mt-6 text-[#1B3A5F] font-semibold flex items-center text-xs sm:text-sm lg:text-base">
                  View {state.name} Details
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Regional Statistics */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-[#1B3A5F] text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4">REGIONAL IMPACT</h2>
            <p className="text-gray-600 text-base sm:text-lg lg:text-xl">Our presence and performance across the central United States</p>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            {[
              {
                icon: 'ri-building-line',
                number: '1,000+',
                label: 'Facilities Served',
                description: 'Industrial plants across our 9-state service area'
              },
              {
                icon: 'ri-truck-line',
                number: '5,000+',
                label: 'Equipment Pickups',
                description: 'Successful removals completed safely and on time'
              },
              {
                icon: 'ri-time-line',
                number: '24 Hour',
                label: 'Response Time',
                description: 'Average response time for quote requests'
              },
              {
                icon: 'ri-team-line',
                number: '50+',
                label: 'Regional Staff',
                description: 'Local experts and certified removal crews'
              }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-12 sm:w-16 lg:w-20 h-12 sm:h-16 lg:h-20 bg-[#1B3A5F] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 lg:mb-6">
                  <i className={`${stat.icon} text-white text-xl sm:text-2xl lg:text-3xl`} aria-hidden="true"></i>
                </div>
                <div className="text-[#1B3A5F] text-2xl sm:text-3xl lg:text-4xl font-bold mb-2">{stat.number}</div>
                <h3 className="text-gray-800 font-bold text-sm sm:text-base lg:text-lg mb-2">{stat.label}</h3>
                <p className="text-gray-600 text-xs sm:text-sm lg:text-base">{stat.description}</p>
              </div>
            ))}
          </div>

          {/* Industry Association Links */}
          <div className="mt-12 sm:mt-16 text-center border-t pt-8 sm:pt-12">
            <p className="text-gray-600 mb-4">Industry associations and standards we follow:</p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              <a 
                href="https://www.afpm.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#1B3A5F] hover:underline text-sm"
              >
                American Fuel & Petrochemical Manufacturers
              </a>
              <a 
                href="https://www.api.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#1B3A5F] hover:underline text-sm"
              >
                American Petroleum Institute
              </a>
              <a 
                href="https://www.awwa.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#1B3A5F] hover:underline text-sm"
              >
                American Water Works Association
              </a>
              <a 
                href="https://www.nace.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#1B3A5F] hover:underline text-sm"
              >
                NACE International
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Regional Teams */}
      <section className="py-12 sm:py-16 lg:py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-white text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4">CONTACT YOUR REGIONAL TEAM</h2>
            <p className="text-gray-200 text-base sm:text-lg lg:text-xl">Get in touch with local experts who understand your area</p>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {[
              {
                region: 'Texas & Louisiana',
                states: 'TX, LA',
                phone: '(214) 854-5638',
                email: 'valvesalessupply@gmail.com',
                manager: 'John Smith, Regional Manager'
              },
              {
                region: 'Oklahoma & Kansas',
                states: 'OK, KS, NM',
                phone: '(214) 854-5638',
                email: 'valvesalessupply@gmail.com',
                manager: 'Sarah Johnson, Regional Manager'
              },
              {
                region: 'Northern Plains',
                states: 'ND, SD, WY, UT',
                phone: '(214) 854-5638',
                email: 'valvesalessupply@gmail.com',
                manager: 'Mike Davis, Regional Manager'
              }
            ].map((region, index) => (
              <div key={index} className="bg-white rounded-xl sm:rounded-2xl lg:rounded-3xl p-4 sm:p-6 lg:p-8 text-center">
                <h3 className="text-[#1B3A5F] text-lg sm:text-xl lg:text-2xl font-bold mb-2">{region.region}</h3>
                <p className="text-[#6B7280] mb-3 sm:mb-4 lg:mb-6 text-xs sm:text-sm lg:text-base">Serving: {region.states}</p>
                
                <div className="space-y-2 sm:space-y-3 lg:space-y-4">
                  <a
                    href={`tel:${region.phone}`}
                    className="block text-[#1B3A5F] font-bold text-base sm:text-lg lg:text-xl hover:underline"
                  >
                    {region.phone}
                  </a>
                  <a
                    href={`mailto:${region.email}`}
                    className="block text-gray-600 hover:text-[#1B3A5F] hover:underline text-xs sm:text-sm lg:text-base break-all"
                  >
                    {region.email}
                  </a>
                  <p className="text-gray-600 text-xs sm:text-sm">{region.manager}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-6 sm:mt-8 lg:mt-12">
            <Link
              to="/contact"
              className="bg-white text-[#1B3A5F] px-6 sm:px-8 lg:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg lg:text-xl font-semibold hover:bg-gray-100 transition-all duration-300 whitespace-nowrap"
            >
              SUBMIT EQUIPMENT LIST
            </Link>
          </div>

          {/* State Economic Development Links */}
          <div className="mt-12 sm:mt-16 text-center border-t border-white/20 pt-8">
            <p className="text-gray-200 mb-4">State economic development resources:</p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4 text-sm">
              <a 
                href="https://gov.texas.gov/business" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-200 hover:text-white underline"
              >
                Texas Economic Development
              </a>
              <a 
                href="https://www.okcommerce.gov" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-200 hover:text-white underline"
              >
                Oklahoma Department of Commerce
              </a>
              <a 
                href="https://www.opportunitylouisiana.gov" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-200 hover:text-white underline"
              >
                Louisiana Economic Development
              </a>
              <a 
                href="https://gonm.biz" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-200 hover:text-white underline"
              >
                New Mexico Economic Development
              </a>
              <a 
                href="https://www.kansascommerce.gov" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-200 hover:text-white underline"
              >
                Kansas Department of Commerce
              </a>
              <a 
                href="https://www.business.nd.gov" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-200 hover:text-white underline"
              >
                North Dakota Commerce
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServiceAreas;
